import React from "react";
import { useTranslation } from "react-i18next";

export default function CheckboxComponent ({field, form, ...props}) {
    
    const [t, i18n] = useTranslation(); /* Added Line */
    return !props.checkboxList ? null :
         (
            <>
                {props.checkboxList.map((option) => (

                    <div className="custom-control custom-checkbox mb-3" key={option.id}>
                        <input
                            disabled={false}
                            className="custom-control-input"
                            type="checkbox"                            
                            name={option.name}
                            id={option.id}
                            value={option.id}
                            checked={option.present}
                            onChange={(event) => {                                
                                let _checkboxList = props.checkboxList;

                                _checkboxList.forEach(chkItem=>{
                                    if(chkItem === option){
                                        form.setFieldValue(option, event.target.checked);
                                        chkItem.isChecked = event.target.checked;
                                        chkItem.present = event.target.checked;
                                    }
                                });
                                //props.checkboxList= _checkboxList
                            }}
                        />
                        <label className="custom-control-label" style={{ display: 'flex'}} htmlFor={option.id}>
                            {option.descr}
                        </label>                        
                    </div>

                ))}
            </>
        );

}

const onChange = (event) => {    
    this.setState({ selectedValue: event.target.value });
};

const handleOnChange=(event,option)=> {    
    let checkboxList = props.checkboxList;
    checkboxList.forEach(chkItem=>{
        if(chkItem === option){
            chkItem.isChecked = event.target.checked;
        }
    })
    this.setState({
        checkboxList: checkboxList
    });
}

const handleOnSubmit=()=>{
    console.table(this.state.checkboxList);
}